import { IndorImages, getIndorImageSrc } from "../../../../features";
import { getMapHighlightBody, getMapLinkBodyTemplate, getObjectCardLinkBodyTemplate } from "./tableCellTemplates";

export function getMapLinkColumn() {
    return {
        headerTemplate: <img src={getIndorImageSrc(IndorImages.Map, 20)} />,
        pdfHeader: "Объект на карте",
        field: "MapLink",
        valueType: "string",
        canBeFiltered: false,
        canBeSorted: false,
        bodyTemplate: getMapLinkBodyTemplate,
        showFilterMenu: false,
        width: 100,
        align: "center"
    }
}

export function getMapHighlightColumn(tableValueUrl: any) {
    return {
        headerTemplate: <img src={getIndorImageSrc(IndorImages.Map, 20)} />,
        pdfHeader: "Объект на карте",
        field: "MapLink",
        valueType: "string",
        canBeFiltered: false,
        canBeSorted: false,
        bodyTemplate: getMapHighlightBody.bind(null, tableValueUrl),
        showFilterMenu: false,
        width: 100,
        align: "center"
    }
}

export function getObjectLinkColumn() {
    return {
        headerTemplate: <img src={getIndorImageSrc(IndorImages.MessageInfo, 20)} />,
        pdfHeader: "Карточка объекта",
        field: "ObjectCardLink",
        valueType: "string",
        canBeFiltered: false,
        canBeSorted: false,
        bodyTemplate: getObjectCardLinkBodyTemplate,
        showFilterMenu: false,
        width: 100,
        align: "center",
    }
}